/**
 * 车辆信息详情，用来审核车辆
 */

import React, { Component } from 'react';
import { Modal, Button, Divider, Row, Col, Form, Input, Table, Tooltip } from 'antd';

import ImageView from '../../ui/ImageView';
import Image from '../../ui/Image';

//引入样式
import './vehicleAuditStyle.css';

import messager from '../../ui/messager';
import http from '../../../axios/http';

//加载中遮罩
import Loading from '../../ui/Loading';
import { global_data } from '../../ui/auth';

//车辆信息修改
import VehicleAuditEdit from './VehicleAuditEdit';


const vehicleField = [{
    "text": "商户",
    "field": "memberName",
}, {
    "text": "状态",
    "field": "statusStr",
}, {
    "text": "VIN",
    "field": "vin",
}, {
    "text": "车牌号",
    "field": "plateNo",
}, {
    "text": "初登日期",
    "field": "registerDate",
}, {
    "text": "品牌型号",
    "field": "brandModel",
}, {
    "text": "使用性质",
    "field": "usePropertyStr",
}, {
    "text": "车主姓名",
    "field": "owner",
}, {
    "text": "车主住所",
    "field": "ownerAddress",
}];

const otherField = [{
    "text": "车辆类型",
    "field": "carTypeStr",
}, {
    "text": "表显里程/万公里",
    "field": "mileage",
}, {
    "text": "商城标价/万元",
    "field": "price",
}, {
    "text": "品牌车型",
    "field": "name",
}, {
    "text": "车身颜色",
    "field": "colorStr",
    // }, {
    //     "text": "排放标准",
    //     "field": "emissionStandard",
}, {
    "text": "车辆所属地",
    "field": "location",
}, {
    "text": "过户次数",
    "field": "transferTimes",
}, {
    "text": "出厂日期",
    "field": "productionDate",
}, {
    "text": "年检到期日期",
    "field": "examinationDate",
}, {
    "text": "交强险到期日期",
    "field": "mandatoryInsuranceDate",
}, {
    "text": "商业险到期日期",
    "field": "commerciaInsuranceDate",
}, {
    "text": "钥匙数量",
    "field": "keyNum",
}, {
    "text": "车况描述对外可见",
    "field": "remarkVisibleStr",
}, {
    "text": "车况描述",
    "field": "mark",
    "colSpan": 3
}, {
    "text": "配置亮点描述",
    "field": "detailHighlight",
    "colSpan": 5
}];

//车辆照片信息
const vehicleImages = [{
    text: '左前',
    field: 'leftFrontImg'
    // }, {
    //     text: '右后',
    //     field: 'rightBackImg'
    // }, {
    //     text: '中控',
    //     field: 'consoleImg'
    // }, {
    //     text: '座椅',
    //     field: 'seatImg'
    // }, {
    //     text: '发动机舱',
    //     field: 'engineImg'
    // }, {
    //     text: '后备箱',
    //     field: 'trunkImg'
}];

//手续照片
const certificationImgs = [{
    text: '行驶证',
    field: 'certificationImgs.licenseImg'
}, {
    text: '登记证第一,二页',
    field: 'certificationImgs.registration12Img'
}, {
    text: '登记证最后两页',
    field: 'certificationImgs.registrationLastImg'
}];



class VehicleAuditDetail extends Component {

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,
        loadingVisible: false,

        failVisible: false, //显示退回输入框

        visible: false, //编辑框显示
    }

    columns = [
        {
            title: '操作时间',
            dataIndex: 'time',
            width: '20%',
        }, {
            title: '操作人',
            dataIndex: 'name',
            width: '10%',
        }, {
            title: '状态',
            dataIndex: 'status',
            width: '10%',
            render: (text, record, index) => {
                let status = { "DRAFT": "草稿", "VERIFYING": "提交", "ONSELLING": "上架", "PUTOFF": "下架", "SOLD": "出售", "VERIFY_FAIL": "退回", "TRADING": "交易中" };
                return status[text];
            }
        }, {
            title: '说明',
            dataIndex: 'info',
            width: '20%',
            render: (text, record, index) => (
                <Tooltip title={text}>
                    <span>{text}</span>
                </Tooltip>
            )
        }];

    creaateDetailTable = (data) => {
        const { editData } = this.props;
        let dom = [];
        let tdNum = 3;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let colSpan = 1;
                if ((i + j) === (data.length - 1)) {
                    colSpan = (tdNum - j) * 2 - 1;
                }
                if (data[i + j]["colSpan"] != null) {
                    colSpan = data[i + j]["colSpan"];
                }
                let field = (<td key={"td" + i + j + 1} colSpan={colSpan}>{editData[data[i + j]["field"]]}</td>);
                td.push(text);
                td.push(field);
                if (data[i + j]["colSpan"] != null) {
                    let d = (data[i + j]["colSpan"] - 1) / 2;
                    i -= d;
                    break;
                }
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="vehicle-detail-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    }

    // 图片列表
    createImageDom = (field) => {
        let dom = [];
        const { editData } = this.props;
        const imgInfos = editData.thumbnails;
        const imaUrls = editData.vehicleImages;
        for (let i = 0; i < field.length; i += 1) {
            let path = imgInfos != null && imgInfos[field[i]["field"]] ? "data:image/jpeg;base64," + imgInfos[field[i]["field"]] : "";
            let imgurl = imaUrls && imaUrls[field[i]["field"]] ? imaUrls[field[i]["field"]] : "";
            let img = this.createImageCol(path, imgurl, field[i].text, i);
            dom.push(img);
        }
        return dom;
    }

    createImageList = (imageKey) => {
        let dom = [];
        const { editData } = this.props;
        let vehicleImages = editData["vehicleImages"];
        let thumbnails = editData["thumbnails"];
        if (vehicleImages == null || thumbnails == null) return;
        let imageList = vehicleImages[imageKey];
        let thumbnailList = thumbnails[imageKey];
        if (thumbnailList != null && thumbnailList.length > 0) {
            thumbnailList.forEach((item, index) => {
                let image = "data:image/jpeg;base64," + item
                let img = this.createImageCol(image, imageList[index], null, index);
                dom.push(img);
            })
        }
        return dom;
    }

    createImageCol = (image, url, text, key) => {
        let img = (
            <Col span={3} key={key} style={{ margin: '5px 0' }}>
                <Image
                    onlyView={true}
                    file={image}
                    text={text}
                    url={url}
                />
            </Col>
        );
        return img;
    }

    //审核车辆
    auditVehicle = (type) => {
        let url = "pass";
        let text = "上架";
        if (type === "ONSELLING") {
            //车辆上架
        } else if (type === "VERIFY_FAIL") {
            //不通过审核
            // url = "fail";
            // text = "退回";
            this.setState({ failVisible: true })
            return;
        } else if (type === "PUTOFF") {
            //强制下架
            url = "putOff";
            text = "下架";
        } else if (type === "EDIT") {
            this.setState({ visible: true });
            return;
        }else if(type === "DELETE"){
            //删除
            url = "deleteVehicle";
            text = "删除";
        }
        messager.confirm("是否" + text + "该车辆？", () => {
            const { editData, successCallback, queryData, onCancel } = this.props;
            this.setState({ loadingVisible: true });
            http.post({
                url: "/vehicleAudit/" + url,
                data: { id: editData.id },
                success: (res) => {
                    this.setState({ loadingVisible: false });
                    onCancel();
                    messager.notify(text + "成功！");
                    queryData.notChangePage = true;
                    successCallback(queryData);
                },
                error: (res) => {
                    this.setState({ loadingVisible: false });
                    messager.alert(res, "异常", "error");
                }
            });
        });
    }

    hiddenModalFail = () => {
        this.setState({ failVisible: false });
    }

    doFailSuccess = () => {
        const { successCallback, queryData, onCancel } = this.props;
        onCancel();
        this.hiddenModalFail();
        queryData.notChangePage = true;
        successCallback(queryData);
    }

    render() {
        const { visible, onCancel, editData } = this.props;
        let operationRecord = editData.operationRecord;
        if (operationRecord == null || operationRecord === "") {
            operationRecord = [];
        } else {
            operationRecord = JSON.parse(operationRecord);
        }
        return (
            <Modal
                width={1200}
                visible={visible}
                title="车辆审核详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                zIndex={1000}
                footer={[
                    (editData["status"] === "VERIFYING"||editData["status"] === "DRAFT")&&global_data.authCode.includes("VEHICLE_AUDIT_UPDATE") ? 
                    <Button key="EDIT" type="primary" onClick={this.auditVehicle.bind(this, "EDIT")}>修改</Button> 
                    : "",
                    editData["status"] === "VERIFYING"&&global_data.authCode.includes("VEHICLE_AUDIT_PUTON") ? 
                    <Button key="ONSELLING" type="primary" onClick={this.auditVehicle.bind(this, "ONSELLING")}>上架</Button> 
                    : "",
                    editData["status"] === "VERIFYING"&&global_data.authCode.includes("VEHICLE_AUDIT_RETURN") ? 
                    <Button key="VERIFY_FAIL" type="danger" onClick={this.auditVehicle.bind(this, "VERIFY_FAIL")}>退回</Button> 
                    : "",
                    global_data.authCode.includes("VEHICLE_AUDIT_DELETE") ? 
                    <Button key="PUTOFF" type="danger" onClick={this.auditVehicle.bind(this, "DELETE")}>删除</Button>
                    :"",
                    editData["status"] === "ONSELLING"&&global_data.authCode.includes("VEHICLE_AUDIT_PUTOFF") ? 
                    <Button key="PUTOFF" type="danger" onClick={this.auditVehicle.bind(this, "PUTOFF")}>下架</Button> 
                    : "",
                    <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                ]}
            >
                <div>
                    <Divider orientation="left">基本信息</Divider>
                    {this.creaateDetailTable(vehicleField)}
                    <Divider orientation="left">其他信息</Divider>
                    {this.creaateDetailTable(otherField)}
                    <Divider orientation="left">手续照片</Divider>
                    <Row>{this.createImageDom(certificationImgs)}</Row>
                    <Divider orientation="left">车辆照片</Divider>
                    <Row>
                        {this.createImageDom(vehicleImages)}
                        {this.createImageList("imageList")}
                    </Row>
                    <Divider orientation="left">其他照片</Divider>
                    <Row>{this.createImageList("otherImgs")}</Row>
                    <Divider orientation="left">车辆审核记录</Divider>
                    <Row>
                        <Table rowKey="time" columns={this.columns} dataSource={operationRecord} pagination={false} />
                    </Row>
                </div>
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据处理中..."
                />
                <VehilceAuditFail
                    visible={this.state.failVisible}
                    onCancel={this.hiddenModalFail.bind(this)}
                    editData={editData}
                    successCallback={this.doFailSuccess}
                />
                <VehicleAuditEdit
                    visible={this.state.visible}
                    editData={editData}
                    onCancel={() => { this.setState({ visible: false }) }}
                    successCallback={() => { this.props.successCallback(this.props.queryData) }}
                />
            </Modal>
        );
    }
}


class VehilceAuditFailForm extends Component {


    failVehilce = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = this.props.editData.id;
            http.post({
                url: "/vehicleAudit/fail",
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    this.props.successCallback();
                    messager.notify("退回成功！");
                }
            });
        });
    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="退回车辆"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.failVehilce}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    <Form.Item label="退回理由：">
                        {getFieldDecorator('auditMind', {
                            rules: [
                                { required: true, message: '退回理由不能为空!' },
                                { max: 256, message: '最多只能输入256个字符！' }],
                        })(
                            <Input.TextArea />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}


const VehilceAuditFail = Form.create()(VehilceAuditFailForm);


export default VehicleAuditDetail;